export default __webpack_public_path__ + "media/images/prezola-voucher-c4a2aa57fbb89d30326204917261bc60.jpg";